class SwatchDescriptionMover extends HTMLElement {
    connectedCallback() {
        this.retries = 0;
        this.move();
    }

    move() {
        const label = Array.from(document.querySelectorAll('.sg__swatch_option-label'))
            .find(el => el.textContent.toLowerCase().includes('size'));

        if (label) {
            label.after(this);
        } else if (this.retries++ < 50) {
            requestAnimationFrame(() => this.move());
        }
    }
}

customElements.define('swatch-description-mover', SwatchDescriptionMover);
